module.exports = "/_next/static/images/Hero-xs-66a79d4f02f723ade060dbfd6259ee60.webp";